import { NgModule } from '@angular/core';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { ZefFormFieldModule, ZefFormsModule } from '@zerops/zef/forms';
import { ProgressErrorContainer } from '@zerops/zef/progress-error/progress-error.container';
import { TranslocoDirective } from '@ngneat/transloco';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { ClientAddDialogFeature } from './client-add-dialog.container';
import { ClientAddDialogEffect } from './client-add-dialog.effect';


@NgModule({
  declarations: [ClientAddDialogFeature],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ ClientAddDialogEffect ]),
    ZefDialogModule,
    ZefScrollbarComponent,
    FormSectionModule,
    ReactiveFormsModule,
    MatLegacyButtonModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    ZefFormFieldModule,
    ZefFormsModule,
    ProgressErrorContainer,
    TranslocoDirective
  ],
  exports: [ClientAddDialogFeature]
})
export class ClientAddDialogModule {}
